import { OrderPreparationStatusName } from "../../../../../services/Api/Organization/types";
import { NumberOrderApi, NumberOrderOrganizationInfoApi } from "../../../../../services/Api/Public/types";

export const getNumberSystemClassName = (item?: NumberOrderApi) => {
	if (!item) return "";

	if (
		item.status === OrderPreparationStatusName.READY ||
		item.status === OrderPreparationStatusName.NEW ||
		item.status === OrderPreparationStatusName.IN_PROGRESS
	) {
		return "default";
	}

	if (item.status === OrderPreparationStatusName.PACKED) return "ready";
};

export const getNumberSystemFilteredItemsByStatuses = (
	items: NumberOrderApi[],
	statuses: OrderPreparationStatusName[]
) => {
	return items.filter((item) => statuses.includes(item.status));
};

export const getNumberSystemFontSize = (organizationInfo: NumberOrderOrganizationInfoApi | undefined) =>
	organizationInfo?.font_size ?? 64;
